module.exports = __webpack_public_path__ + "img/Cart.4a178c3f.svg";